import { default as energy_45green_45practiceszWAC2A2gNnMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journeyhKnYoT23YHMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45builderv8uGQawFVAMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as indexbMkCQ3B8CvMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45teaminPflWiu64Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lenderDDJhQJn4q4Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resources73o4sEJdjTMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_93h3gBplddjJMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexSbBC4u1eDZMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as indexP1xUi0hrl8Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_9325uD1bmQsXMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as index3xiIyVBqEzMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offerrapqZVXmsuMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45question2mtIZfRnmTMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesmOWzDzf2yJMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faqwgQ7NyvEBeMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resourcesn4SXxkJurtMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as index29faLiLEcIMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsI0mo8Vne4lMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offers2fOlPaGcsCMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexDySbZ19j6tMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indexTBliW7YaW9Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as indexh3UOLvW3ADMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexsguVECAAd7Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as indexRiCuzecvolMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexqusOL2IZrHMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexWudRHxDxpbMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationFYm6HmXLCzMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisitionuhvQvpPy3ZMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45placeEA6uG1PVlbMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenanceKE05CR2gb7Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_93jewugNDR8PMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as indexzQFnplQvGjMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as indexnQhG42hRONMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullnessQWhT4zsctTMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93HFj0LOqRmzMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favorites0vrdA8ZrEcMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45searchwzteuS6PrPMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhouse2ZVPHYH2nLMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededitionVeDc9m294PMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottageQD6OSgdkkVMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as indexuELbIS7nMSMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoodsb0lEAVbyWiMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45usDWZK2nizHoMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as peacockDz98pZFvS4Meta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as privacytermsy3RYtUAQBFMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxVmADW9NQ3JMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_93iXpScfHq4SMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stubI1sAWn6i7VMeta } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubI1sAWn6i7V } from "/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practiceszWAC2A2gNnMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practiceszWAC2A2gNnMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practiceszWAC2A2gNnMeta || {},
    alias: energy_45green_45practiceszWAC2A2gNnMeta?.alias || [],
    redirect: energy_45green_45practiceszWAC2A2gNnMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journeyhKnYoT23YHMeta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journeyhKnYoT23YHMeta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journeyhKnYoT23YHMeta || {},
    alias: fun_45part_45journeyhKnYoT23YHMeta?.alias || [],
    redirect: fun_45part_45journeyhKnYoT23YHMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45builderv8uGQawFVAMeta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45builderv8uGQawFVAMeta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45builderv8uGQawFVAMeta || {},
    alias: homesafe_45colorado_45master_45builderv8uGQawFVAMeta?.alias || [],
    redirect: homesafe_45colorado_45master_45builderv8uGQawFVAMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: indexbMkCQ3B8CvMeta?.name ?? "about-us",
    path: indexbMkCQ3B8CvMeta?.path ?? "/about-us",
    meta: indexbMkCQ3B8CvMeta || {},
    alias: indexbMkCQ3B8CvMeta?.alias || [],
    redirect: indexbMkCQ3B8CvMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45teaminPflWiu64Meta?.name ?? "about-us-our-team",
    path: our_45teaminPflWiu64Meta?.path ?? "/about-us/our-team",
    meta: our_45teaminPflWiu64Meta || {},
    alias: our_45teaminPflWiu64Meta?.alias || [],
    redirect: our_45teaminPflWiu64Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lenderDDJhQJn4q4Meta?.name ?? "about-us-preferred-lender",
    path: preferred_45lenderDDJhQJn4q4Meta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lenderDDJhQJn4q4Meta || {},
    alias: preferred_45lenderDDJhQJn4q4Meta?.alias || [],
    redirect: preferred_45lenderDDJhQJn4q4Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resources73o4sEJdjTMeta?.name ?? "about-us-realtor-resources",
    path: realtor_45resources73o4sEJdjTMeta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resources73o4sEJdjTMeta || {},
    alias: realtor_45resources73o4sEJdjTMeta?.alias || [],
    redirect: realtor_45resources73o4sEJdjTMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_93h3gBplddjJMeta?.name ?? "blog-post",
    path: _91post_93h3gBplddjJMeta?.path ?? "/blog/:post()",
    meta: _91post_93h3gBplddjJMeta || {},
    alias: _91post_93h3gBplddjJMeta?.alias || [],
    redirect: _91post_93h3gBplddjJMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexSbBC4u1eDZMeta?.name ?? "blog-category-category",
    path: indexSbBC4u1eDZMeta?.path ?? "/blog/category/:category()",
    meta: indexSbBC4u1eDZMeta || {},
    alias: indexSbBC4u1eDZMeta?.alias || [],
    redirect: indexSbBC4u1eDZMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexP1xUi0hrl8Meta?.name ?? "blog",
    path: indexP1xUi0hrl8Meta?.path ?? "/blog",
    meta: indexP1xUi0hrl8Meta || {},
    alias: indexP1xUi0hrl8Meta?.alias || [],
    redirect: indexP1xUi0hrl8Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_9325uD1bmQsXMeta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_9325uD1bmQsXMeta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_9325uD1bmQsXMeta || {},
    alias: _91_46_46_46slug_9325uD1bmQsXMeta?.alias || [],
    redirect: _91_46_46_46slug_9325uD1bmQsXMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index3xiIyVBqEzMeta?.name ?? "campaigns",
    path: index3xiIyVBqEzMeta?.path ?? "/campaigns",
    meta: index3xiIyVBqEzMeta || {},
    alias: index3xiIyVBqEzMeta?.alias || [],
    redirect: index3xiIyVBqEzMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offerrapqZVXmsuMeta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offerrapqZVXmsuMeta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offerrapqZVXmsuMeta || {},
    alias: central_45park_45special_45offerrapqZVXmsuMeta?.alias || [],
    redirect: central_45park_45special_45offerrapqZVXmsuMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45question2mtIZfRnmTMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45question2mtIZfRnmTMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45question2mtIZfRnmTMeta || {},
    alias: ask_45a_45question2mtIZfRnmTMeta?.alias || [],
    redirect: ask_45a_45question2mtIZfRnmTMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesmOWzDzf2yJMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesmOWzDzf2yJMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesmOWzDzf2yJMeta || {},
    alias: career_45opportunitiesmOWzDzf2yJMeta?.alias || [],
    redirect: career_45opportunitiesmOWzDzf2yJMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faqwgQ7NyvEBeMeta?.name ?? "contact-us-faq",
    path: faqwgQ7NyvEBeMeta?.path ?? "/contact-us/faq",
    meta: faqwgQ7NyvEBeMeta || {},
    alias: faqwgQ7NyvEBeMeta?.alias || [],
    redirect: faqwgQ7NyvEBeMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resourcesn4SXxkJurtMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resourcesn4SXxkJurtMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resourcesn4SXxkJurtMeta || {},
    alias: homeowner_45resourcesn4SXxkJurtMeta?.alias || [],
    redirect: homeowner_45resourcesn4SXxkJurtMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: index29faLiLEcIMeta?.name ?? "contact-us",
    path: index29faLiLEcIMeta?.path ?? "/contact-us",
    meta: index29faLiLEcIMeta || {},
    alias: index29faLiLEcIMeta?.alias || [],
    redirect: index29faLiLEcIMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsI0mo8Vne4lMeta?.name ?? "contact-us-our-locations",
    path: our_45locationsI0mo8Vne4lMeta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsI0mo8Vne4lMeta || {},
    alias: our_45locationsI0mo8Vne4lMeta?.alias || [],
    redirect: our_45locationsI0mo8Vne4lMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offers2fOlPaGcsCMeta?.name ?? "current-offers",
    path: current_45offers2fOlPaGcsCMeta?.path ?? "/current-offers",
    meta: current_45offers2fOlPaGcsCMeta || {},
    alias: current_45offers2fOlPaGcsCMeta?.alias || [],
    redirect: current_45offers2fOlPaGcsCMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: indexDySbZ19j6tMeta?.name ?? "events-event",
    path: indexDySbZ19j6tMeta?.path ?? "/events/:event()",
    meta: indexDySbZ19j6tMeta || {},
    alias: indexDySbZ19j6tMeta?.alias || [],
    redirect: indexDySbZ19j6tMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indexTBliW7YaW9Meta?.name ?? "events",
    path: indexTBliW7YaW9Meta?.path ?? "/events",
    meta: indexTBliW7YaW9Meta || {},
    alias: indexTBliW7YaW9Meta?.alias || [],
    redirect: indexTBliW7YaW9Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: indexh3UOLvW3ADMeta?.name ?? "homes-location-community",
    path: indexh3UOLvW3ADMeta?.path ?? "/homes/:location()/:community()",
    meta: indexh3UOLvW3ADMeta || {},
    alias: indexh3UOLvW3ADMeta?.alias || [],
    redirect: indexh3UOLvW3ADMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexsguVECAAd7Meta?.name ?? "homes-location-community-models-model",
    path: indexsguVECAAd7Meta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexsguVECAAd7Meta || {},
    alias: indexsguVECAAd7Meta?.alias || [],
    redirect: indexsguVECAAd7Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: indexRiCuzecvolMeta?.name ?? "homes-location-community-plans-plan",
    path: indexRiCuzecvolMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: indexRiCuzecvolMeta || {},
    alias: indexRiCuzecvolMeta?.alias || [],
    redirect: indexRiCuzecvolMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: indexqusOL2IZrHMeta?.name ?? "homes-location-community-qmi-home",
    path: indexqusOL2IZrHMeta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: indexqusOL2IZrHMeta || {},
    alias: indexqusOL2IZrHMeta?.alias || [],
    redirect: indexqusOL2IZrHMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: indexWudRHxDxpbMeta?.name ?? "index",
    path: indexWudRHxDxpbMeta?.path ?? "/",
    meta: indexWudRHxDxpbMeta || {},
    alias: indexWudRHxDxpbMeta?.alias || [],
    redirect: indexWudRHxDxpbMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationFYm6HmXLCzMeta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationFYm6HmXLCzMeta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationFYm6HmXLCzMeta || {},
    alias: knolls_45hoa_45informationFYm6HmXLCzMeta?.alias || [],
    redirect: knolls_45hoa_45informationFYm6HmXLCzMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisitionuhvQvpPy3ZMeta?.name ?? "land-acquisition",
    path: land_45acquisitionuhvQvpPy3ZMeta?.path ?? "/land-acquisition",
    meta: land_45acquisitionuhvQvpPy3ZMeta || {},
    alias: land_45acquisitionuhvQvpPy3ZMeta?.alias || [],
    redirect: land_45acquisitionuhvQvpPy3ZMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45placeEA6uG1PVlbMeta?.name ?? "lifestyle-brents-place",
    path: brents_45placeEA6uG1PVlbMeta?.path ?? "/lifestyle/brents-place",
    meta: brents_45placeEA6uG1PVlbMeta || {},
    alias: brents_45placeEA6uG1PVlbMeta?.alias || [],
    redirect: brents_45placeEA6uG1PVlbMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenanceKE05CR2gb7Meta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenanceKE05CR2gb7Meta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenanceKE05CR2gb7Meta || {},
    alias: experience_45lower_45maintenanceKE05CR2gb7Meta?.alias || [],
    redirect: experience_45lower_45maintenanceKE05CR2gb7Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_93jewugNDR8PMeta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_93jewugNDR8PMeta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_93jewugNDR8PMeta || {},
    alias: _91testimonial_93jewugNDR8PMeta?.alias || [],
    redirect: _91testimonial_93jewugNDR8PMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: indexzQFnplQvGjMeta?.name ?? "lifestyle-reviews-category-category",
    path: indexzQFnplQvGjMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: indexzQFnplQvGjMeta || {},
    alias: indexzQFnplQvGjMeta?.alias || [],
    redirect: indexzQFnplQvGjMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexnQhG42hRONMeta?.name ?? "lifestyle-reviews",
    path: indexnQhG42hRONMeta?.path ?? "/lifestyle/reviews",
    meta: indexnQhG42hRONMeta || {},
    alias: indexnQhG42hRONMeta?.alias || [],
    redirect: indexnQhG42hRONMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullnessQWhT4zsctTMeta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullnessQWhT4zsctTMeta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullnessQWhT4zsctTMeta || {},
    alias: whats_45lifefullnessQWhT4zsctTMeta?.alias || [],
    redirect: whats_45lifefullnessQWhT4zsctTMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93HFj0LOqRmzMeta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93HFj0LOqRmzMeta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93HFj0LOqRmzMeta || {},
    alias: _91_46_46_46slug_93HFj0LOqRmzMeta?.alias || [],
    redirect: _91_46_46_46slug_93HFj0LOqRmzMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites0vrdA8ZrEcMeta?.name ?? "my-favorites",
    path: my_45favorites0vrdA8ZrEcMeta?.path ?? "/my-favorites",
    meta: my_45favorites0vrdA8ZrEcMeta || {},
    alias: my_45favorites0vrdA8ZrEcMeta?.alias || [],
    redirect: my_45favorites0vrdA8ZrEcMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45searchwzteuS6PrPMeta?.name ?? "new-home-search",
    path: new_45home_45searchwzteuS6PrPMeta?.path ?? "/new-home-search",
    meta: new_45home_45searchwzteuS6PrPMeta || {},
    alias: new_45home_45searchwzteuS6PrPMeta?.alias || [],
    redirect: new_45home_45searchwzteuS6PrPMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhouse2ZVPHYH2nLMeta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhouse2ZVPHYH2nLMeta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhouse2ZVPHYH2nLMeta || {},
    alias: easyhouse2ZVPHYH2nLMeta?.alias || [],
    redirect: easyhouse2ZVPHYH2nLMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededitionVeDc9m294PMeta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededitionVeDc9m294PMeta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededitionVeDc9m294PMeta || {},
    alias: limitededitionVeDc9m294PMeta?.alias || [],
    redirect: limitededitionVeDc9m294PMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottageQD6OSgdkkVMeta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottageQD6OSgdkkVMeta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottageQD6OSgdkkVMeta || {},
    alias: wee_45cottageQD6OSgdkkVMeta?.alias || [],
    redirect: wee_45cottageQD6OSgdkkVMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: indexuELbIS7nMSMeta?.name ?? "our-homes",
    path: indexuELbIS7nMSMeta?.path ?? "/our-homes",
    meta: indexuELbIS7nMSMeta || {},
    alias: indexuELbIS7nMSMeta?.alias || [],
    redirect: indexuELbIS7nMSMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoodsb0lEAVbyWiMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoodsb0lEAVbyWiMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoodsb0lEAVbyWiMeta || {},
    alias: our_45neighborhoodsb0lEAVbyWiMeta?.alias || [],
    redirect: our_45neighborhoodsb0lEAVbyWiMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45usDWZK2nizHoMeta?.name ?? "partner-with-us",
    path: partner_45with_45usDWZK2nizHoMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45usDWZK2nizHoMeta || {},
    alias: partner_45with_45usDWZK2nizHoMeta?.alias || [],
    redirect: partner_45with_45usDWZK2nizHoMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: peacockDz98pZFvS4Meta?.name ?? "peacock",
    path: peacockDz98pZFvS4Meta?.path ?? "/peacock",
    meta: peacockDz98pZFvS4Meta || {},
    alias: peacockDz98pZFvS4Meta?.alias || [],
    redirect: peacockDz98pZFvS4Meta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/peacock.vue").then(m => m.default || m)
  },
  {
    name: privacytermsy3RYtUAQBFMeta?.name ?? "privacyterms",
    path: privacytermsy3RYtUAQBFMeta?.path ?? "/privacyterms",
    meta: privacytermsy3RYtUAQBFMeta || {},
    alias: privacytermsy3RYtUAQBFMeta?.alias || [],
    redirect: privacytermsy3RYtUAQBFMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxVmADW9NQ3JMeta?.name ?? "sandbox",
    path: sandboxVmADW9NQ3JMeta?.path ?? "/sandbox",
    meta: sandboxVmADW9NQ3JMeta || {},
    alias: sandboxVmADW9NQ3JMeta?.alias || [],
    redirect: sandboxVmADW9NQ3JMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93iXpScfHq4SMeta?.name ?? "videos-slug",
    path: _91_46_46_46slug_93iXpScfHq4SMeta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_93iXpScfHq4SMeta || {},
    alias: _91_46_46_46slug_93iXpScfHq4SMeta?.alias || [],
    redirect: _91_46_46_46slug_93iXpScfHq4SMeta?.redirect,
    component: () => import("/codebuild/output/src3383959415/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/about-us/in-the-news/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/about-us/realtor-program/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/about-us/what-we-do/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/about-us/who-we-are/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/build-with-us/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/career-opportunities/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/email-signup/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/get-updates/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/get-updates/thank-you/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/how-to-video-library/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/lifestyle/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/locations/silver-leaf/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/login/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/lost-password/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/maintenance-items/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/organism-page/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/home-collections/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/register/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/reset-password/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/style-guide/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  },
  {
    name: component_45stubI1sAWn6i7VMeta?.name ?? undefined,
    path: component_45stubI1sAWn6i7VMeta?.path ?? "/warranty-service-request/",
    meta: component_45stubI1sAWn6i7VMeta || {},
    alias: component_45stubI1sAWn6i7VMeta?.alias || [],
    redirect: component_45stubI1sAWn6i7VMeta?.redirect,
    component: component_45stubI1sAWn6i7V
  }
]